import { render } from "./tw-badge.vue?vue&type=template&id=44aec44a"
import script from "./tw-badge.vue?vue&type=script&lang=js"
export * from "./tw-badge.vue?vue&type=script&lang=js"
script.render = render

export default script